/**
 * Dialog prompting the viewer to sign into an Alias before an Alias-gated action.
 */

import { Dialog, Portal } from '@ark-ui/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from './Button';

export interface AliasSignInPromptProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Optional override for body copy (defaults to spaces.signInBody). */
  bodyKey?: string;
}

export function AliasSignInPrompt({
  open,
  onOpenChange,
  bodyKey = 'spaces.signInBody',
}: AliasSignInPromptProps) {
  const { t } = useTranslation();

  return (
    <Dialog.Root open={open} onOpenChange={(e) => onOpenChange(e.open)}>
      <Portal>
        <Dialog.Backdrop className="confirm-dialog-backdrop" />
        <Dialog.Positioner className="confirm-dialog-positioner">
          <Dialog.Content className="confirm-dialog-content">
            <div className="confirm-dialog-header">
              <Dialog.Title className="confirm-dialog-title">
                {t('spaces.signInHeading')}
              </Dialog.Title>
            </div>
            <div className="confirm-dialog-body">
              <Dialog.Description className="confirm-dialog-description">
                {t(bodyKey)}
              </Dialog.Description>
            </div>
            <div className="confirm-dialog-footer">
              <Button variant="secondary" onClick={() => onOpenChange(false)}>
                {t('common.cancel')}
              </Button>
              <Link
                to="/identity/profile"
                className="btn btn-primary btn-md"
                onClick={() => onOpenChange(false)}
              >
                {t('spaces.signInCta')}
              </Link>
            </div>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
